import { render, staticRenderFns } from "./SegmentOffers.vue?vue&type=template&id=74b7f063"
import script from "./SegmentOffers.vue?vue&type=script&lang=ts"
export * from "./SegmentOffers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports